/**
 * @desc 查看编辑通知设置角色及方式
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 通知设置ID */
  id: number;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.IotRolesAndWaysResult>> {
  return defHttp.get({
    url: '/web/alert/rule/getRolesAndWays',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.IotRolesAndWaysResult>> {
  return defHttp.get({
    url: '/mock/web/alert/rule/getRolesAndWays',

    params,
  });
}
